export const QUIZ_LENGTH = 10;
export const QUIZ_SHARE_URL = 'https://www.asmrchurch.com/quiz/reformation';

export function quizResult(score, total) {
  const ratio = total > 0 ? score / total : 0;
  return {
    percent: Math.round(ratio * 100),
    faithIndex: Math.round(30 + ratio * 40),
    rank: ratio >= 0.8 ? 'A' : ratio >= 0.5 ? 'B' : 'C',
  };
}

export function quizShareText(score, total, review = false) {
  const { faithIndex, rank } = quizResult(score, total);
  return `信仰クイズ${review ? '（復習）' : ''}の結果：${total}問中${score}問正解！\n信仰偏差値 ${faithIndex}（クイズ内の目安）／ランク${rank}\n#信仰クイズ`;
}

function shuffle(items, random) {
  const copy = [...items];
  for (let i = copy.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}

// Keep the source bank unchanged, and move the answer with its choice.
export function createQuiz(items, count = QUIZ_LENGTH, random = Math.random) {
  return shuffle(items, random).slice(0, count).map(question => {
    const order = shuffle(question.choices.map((_, index) => index), random);
    return {
      ...question,
      choices: order.map(index => question.choices[index]),
      answer: order.indexOf(question.answer),
    };
  });
}
